/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import {
  faarrowrightclassicregular,
  fabellclassicregular,
  famagnifyingglassclassicregular,
  famessageclassicregular,
  fauserclassicregular,
  FontAwesomeIcon,
  GrcPopover,
  GrcTextBox,
  IconProp,
  GrcPopup
} from '@grc/ui-package';
import { useI18nState } from '../../../stores/settings/language-context';
import { useCarrierPortalGlobalStore } from '../../../stores/carrier-portal-global-store';
import ProfileArrowIcon from '../../../common/icons/header-icon';
import CollapseIcon from '../../../common/icons/collapase-icon';
import {
  useSettingContext,
  useSettingDispatch
} from '../../../contexts/settings/setting-menu-header-context';
import LogoutButton from '../../../auth0/logout';
import avatar from '../../../common/images/Avatar.png';
import SettingsMenu from '../side-nav/settings-menu/settings-menu';
import { headerPopoverWidth } from '../../../common/constants/constants';
import { MenuItems } from '../side-nav/side-menu/menu';
import ViewProfile from '../view-profile';
import './header.scss';

const Header = () => {
  const [isProfilePopOverVisible, setIsProfilePopOverVisible] = useState(false);
  const [isGlobalSearchVisible, setIsGlobalSearchVisible] = useState(false);
  const { localeData } = useI18nState();
  const { setIsSettingsDrawerOpened } = useSettingDispatch();
  const { isSettingsDrawerOpened } = useSettingContext();
  const [selectedMenu] = useCarrierPortalGlobalStore(
    store => store.menu.selectedMenu
  );
  const [isViewProfileVisible, setIsViewProfileVisible] =
    useState<boolean>(false);
  const [isSideNavOpened, setIsSideNavOpened] =
    useCarrierPortalGlobalStore<boolean>(store => store.menu.isSideNavOpened);

  const getParentMenuText = (menuText: string) => {
    const menuItem = MenuItems.find(item => item.text === menuText);
    if (menuItem && menuItem.parentId !== 0) {
      const parentItem = MenuItems.find(item => item.id === menuItem.parentId);
      return parentItem ? parentItem.text : menuText;
    }
    return menuText;
  };

  const parentMenuText = getParentMenuText(selectedMenu);

  return (
    <>
      <div className="header-layout">
        <nav className="navbar navbar-expand-lg navbar-light bg-white">
          <span
            className={
              !isSideNavOpened
                ? 'expand-icon  cursor-p'
                : '  collpase-icon cursor-p'
            }
            onClick={() => {
              setIsSideNavOpened(!isSideNavOpened);
            }}
          >
            <CollapseIcon />
          </span>
          <a className="navbar-brand mx-2">{parentMenuText}</a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <div className="d-flex mx-3">
              <div className="d-flex">
                {isGlobalSearchVisible && (
                  <div className="global-search">
                    <GrcTextBox placeholder={localeData.Search} />
                  </div>
                )}
                <div
                  className="mr-2 cursor-p"
                  onClick={() => {
                    setIsGlobalSearchVisible(prevState => !prevState);
                  }}
                >
                  <FontAwesomeIcon
                    className="header-icon"
                    icon={famagnifyingglassclassicregular as IconProp}
                    fontSize={18}
                    color="#4767C9"
                  />
                </div>
              </div>

              <div className="mx-2">
                <FontAwesomeIcon
                  className="header-icon"
                  icon={famessageclassicregular as IconProp}
                  color="#4767C9"
                  fontSize={20}
                />
              </div>
              <div className="mx-2">
                <FontAwesomeIcon
                  className="header-icon"
                  icon={fabellclassicregular as IconProp}
                  color="#4767C9"
                  fontSize={20}
                />
              </div>
            </div>

            <div className="navbar-nav mr-auto">
              <div className="user-profile">
                <img src={avatar} alt="" />
              </div>
              <div className="user-details">
                <div className="user-name">{'Wilson Culhane'}</div>
                <div className="user-designation">{'Admin'}</div>
              </div>
              <ul className="navbar-nav mr-auto">
                <li className="nav-item dropdown cursor-p d-flex align-items-center">
                  <div>
                    <div
                      id="profile"
                      onClick={() => {
                        isProfilePopOverVisible
                          ? setIsProfilePopOverVisible(false)
                          : setIsProfilePopOverVisible(true);
                      }}
                    >
                      <ProfileArrowIcon />
                    </div>
                    <GrcPopover
                      target="#profile"
                      className="settings-popover"
                      visible={isProfilePopOverVisible}
                      onHiding={() => {
                        setIsProfilePopOverVisible(false);
                      }}
                      width={headerPopoverWidth}
                    >
                      <div className="profile-settings cursor-p d-flex flex-column p-2">
                        <div
                          className="profile-setting cursor-p d-flex"
                          onClick={() => {
                            setIsViewProfileVisible(
                              (prevState: boolean) => !prevState
                            );
                          }}
                        >
                          <FontAwesomeIcon
                            icon={fauserclassicregular as IconProp}
                            fontSize={18}
                          />
                          <span className="d-block">
                            {localeData.ViewProfile}
                          </span>
                        </div>
                        <div
                          className="theme-setting cursor-p d-flex"
                          onClick={() => {
                            setIsSettingsDrawerOpened(
                              (prevState: boolean) => !prevState
                            );
                          }}
                        >
                          <FontAwesomeIcon
                            icon={fauserclassicregular as IconProp}
                            fontSize={18}
                          />
                          <span className="d-block">{localeData.Themes}</span>
                        </div>
                        <div
                          className="theme-setting cursor-p d-flex"
                          onClick={() => {
                            setIsSettingsDrawerOpened(
                              (prevState: boolean) => !prevState
                            );
                          }}
                        >
                          <FontAwesomeIcon
                            icon={fauserclassicregular as IconProp}
                            fontSize={18}
                          />
                          <span className="d-block">
                            {localeData.Languages}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex cursor-p p-2 align-items-center">
                        <span className="mx-2">
                          <LogoutButton />
                        </span>
                      </div>
                    </GrcPopover>
                  </div>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    <a className="dropdown-item" href="#">
                      Action
                    </a>
                    <a className="dropdown-item" href="#">
                      Another action
                    </a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item" href="#">
                      Something else here
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      {isSettingsDrawerOpened && (
        <SettingsMenu setIsSettingsDrawerOpened={setIsSettingsDrawerOpened} />
      )}

      {isViewProfileVisible && (
        <GrcPopup
          visible={isViewProfileVisible || isGlobalSearchVisible}
          onHiding={() => {
            if (isViewProfileVisible) {
              setIsViewProfileVisible(prevState => !prevState);
            } else if (isGlobalSearchVisible) {
              setIsGlobalSearchVisible(prevState => !prevState);
            }
          }}
          dragEnabled={true}
          hideOnOutsideClick={true}
          showCloseButton={true}
          title={isViewProfileVisible ? localeData.MyProfile : ''}
          className={
            isViewProfileVisible ? 'view-profile' : 'global-search-popup'
          }
          showTitle={isViewProfileVisible}
          width={isViewProfileVisible ? 1000 : 700}
          height={isViewProfileVisible ? 550 : 'auto'}
          position={{
            at: 'top',
            my: 'top',
            of: window,
            offset: isViewProfileVisible ? '0 30' : '0 0'
          }}
        >
          <div>
            <ViewProfile />
          </div>
        </GrcPopup>
      )}
    </>
  );
};

export default Header;
